import { render, staticRenderFns } from "./Boris.vue?vue&type=template&id=387e3e30&scoped=true&"
import script from "./Boris.vue?vue&type=script&lang=js&"
export * from "./Boris.vue?vue&type=script&lang=js&"
import style0 from "./Boris.vue?vue&type=style&index=0&id=387e3e30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387e3e30",
  null
  
)

export default component.exports